import React from 'react';
import { DollarSign, TrendingUp, PieChart, Flame } from 'lucide-react';

const PLANNED_CAPABILITIES = [
  {
    icon: <Flame className="w-5 h-5 text-orange-400" />,
    title: 'Burn Rate',
    description: 'Token spend per week per department, trended over rolling 4-week windows.',
  },
  {
    icon: <PieChart className="w-5 h-5 text-cyan-400" />,
    title: 'Cost per Epic',
    description: 'Actual LLM cost attributable to each epic, aggregated from skill invocations.',
  },
  {
    icon: <TrendingUp className="w-5 h-5 text-emerald-400" />,
    title: 'Budget Allocation',
    description: 'Approved budget by department, utilisation vs. ceiling, reallocation controls.',
  },
];

export const TreasuryView: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-slate-100 mb-2 flex items-center gap-3">
          <DollarSign className="w-7 h-7 text-emerald-400" />
          Treasury
        </h1>
        <p className="text-slate-400">
          Financial oversight for the autonomous company — burn rate, cost per epic, and budget allocation.
        </p>
      </div>

      <div className="bg-slate-800 border border-slate-700 rounded-lg p-8">
        <div className="flex items-center gap-3 mb-4">
          <span className="px-3 py-1 bg-yellow-900 text-yellow-200 text-xs font-semibold rounded-full uppercase tracking-wider">
            Coming Soon
          </span>
        </div>
        <p className="text-slate-300 mb-6 leading-relaxed">
          Treasury is being wired to the platform's logbook and skill invocation data.
          Once connected, it will give you real-time visibility into exactly where tokens and money go.
        </p>

        <div className="space-y-4">
          {PLANNED_CAPABILITIES.map(cap => (
            <div key={cap.title} className="flex items-start gap-4 p-4 bg-slate-900/60 rounded-lg border border-slate-700/50">
              <div className="mt-0.5 shrink-0">{cap.icon}</div>
              <div>
                <p className="text-sm font-semibold text-slate-200 mb-1">{cap.title}</p>
                <p className="text-sm text-slate-400">{cap.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
